/**
 * Inline SVG icons, as strings. The subset this site uses, taken from BirdJournal.SupportSite's own set
 * so that a control appearing on both reads identically. Every icon inherits `currentColor`.
 */
export const icons = {
  // NOT on the 24px stroked grid: it is the blog header's external-link arrow, copied path-for-path so
  // the birdjournal.com link is the same control on the blog, the support site and here.
  external:
    '<svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true"><path fill="currentColor" d="M5 3h8v8h-2V6.41l-6.3 6.3-1.4-1.42L9.58 5H5V3Z"/></svg>',
  signOut:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 17l5-5-5-5M20 12H9M12 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h6"/></svg>',
  account:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21v-1c0-3.3 3.6-5 8-5s8 1.7 8 5v1"/></svg>',
}
